import { ReactElement } from 'react';
import { S_Card } from '../../../design/card/card/S_Cards';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../modules/common/layouts/columnLayout/ColumnLayout';
import { IntegrationsHeader } from '../../modules/integration/components/IntegrationsHeader';
import { CreateApiKeyFormContainer } from '../../modules/integration/containers/CreateApiKeyForm.container';
import { IntegrationsListContainer } from '../../modules/integration/containers/integrationsList.container';

export const IntegrationsView = (): ReactElement => (
  <DashboardContainer>
    <IntegrationsHeader />
    <S_Card>
      <ColumnLayout size='sm'>
        <CreateApiKeyFormContainer />
        <IntegrationsListContainer />
      </ColumnLayout>
    </S_Card>
  </DashboardContainer>
);
